import script from "./VoiceRecorder.vue?vue&type=script&lang=ts&setup=true"
export * from "./VoiceRecorder.vue?vue&type=script&lang=ts&setup=true"

import "./VoiceRecorder.vue?vue&type=style&index=0&id=cbdd935a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbdd935a"]])

export default __exports__